import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import EquipmentRatingPopup from "../Popup/EquipmentRatingPopup";
import { formatLocalString } from "../../utils/validation";
import { useLanguage } from "../../hooks/useLanguage";
import star_yell from "../../assets/icon/star_yell.svg";
import star_default from "../../assets/icon/star_gray.svg";

function MyTop({myInfo}){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isEquipmentPopup, setEquipmentPopup] = useState(false);
  const [isMobileWide, setIsMobileWide] = useState(false);

  // 모바일사이즈 체크
  useEffect(() => {
    const checkMobileWide = () => {
      const width = window.innerWidth;
      setIsMobileWide(width < 1280);
    };

    checkMobileWide();
    window.addEventListener('resize', checkMobileWide);

    return () => window.removeEventListener('resize', checkMobileWide);
  }, []);

  const handleEquipmentPopup = () => {
    setEquipmentPopup(true)
  };

  const renderStarRating = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <img key={i} src={star_yell} alt="star" loading="lazy" />
      );
    }
    
    if (hasHalfStar) {
      stars.push(
        <img key="half" src={star_yell} alt="star" loading="lazy" style={{opacity: 0.5}} />
      );
    }
    
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <img key={`empty-${i}`} src={star_default} alt="star" loading="lazy" />
      );
    }
    
    return stars;
  };

  return(
    <div className="user_box">
      <div className="info_box">
        <p style={isMobileWide ? {display: 'flex', justifyContent: 'space-between', gap: '16px'} : {}}>
          <span>
            {t('welcome_message')}<br />
            <strong className="fw-500">{myInfo?.user_name} </strong>
            {t('member_info2')}
            <strong className="fw-500"> [{myInfo?.mem_kind_txt}] </strong>
            {t('member_info3')}
          </span>
          {isMobileWide && (
            <span
              className="text_small g-80"
              onClick={() => navigate('/myPage/profile/edit')}
              style={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontSize: '11px',
                color: '#999',
                marginTop: 'auto'
              }}
            >
              {t('member_info_2')} >
            </span>
          )}
        </p>
        {!isMobileWide && (
          <div className="box_line point_info">
            <button
              className="text_small g-80"
              type="button"
              onClick={() => navigate('/myPage/profile/edit')}
            > 
              {t('member_info_2')}
            </button>
          </div>
        )}
      </div>
      <div className="counting_box">
        <p className="tit" style={isMobileWide ? {display: 'flex', alignItems: 'center', justifyContent: 'space-between'} : {}}>
          <span style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
            <i className="equip_icon"></i>
            <span>{t('equipment_rating')}</span>
          </span>

        </p>
        <div>
          <div className="review">
            <div className="star_rating_display" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <ul className='rating_list' style={{display: 'flex', gap: '2px', margin: 0, padding: 0, listStyle: 'none'}}>
                {renderStarRating(myInfo?.avg_grade_star || 0)}
              </ul>
              {/* <span style={{fontSize: '14px', color: '#666'}}>
                {myInfo?.avg_grade_star || 0}
              </span> */}
            </div>
          </div>
          {/* pc 장비사용평점 알아보기 */}
          {!isMobileWide && (
            <div className="point_info" style={{marginTop: '5px'}}>
              <button
                className="text_small g-80"
                type="button"
                onClick={handleEquipmentPopup}
              >
                {t('equipment_rating_info').split('<br/>').map((line, idx, arr) => (
                  <React.Fragment key={idx}>
                    {line}
                    {idx < arr.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </button>
            </div>
          )}
          {/* 모바일 장비사용펌점 알아보기 */}
          {isMobileWide && (
            <span
            className="text_small g-80"
            type="button"
            onClick={handleEquipmentPopup}
          >
            {t('equipment_rating_info').split('<br/>').map((line, idx, arr) => (
              <React.Fragment key={idx}>
                {line}
                {idx < arr.length - 1 && <br />}
              </React.Fragment>
            ))} >
          </span>
          )}
        </div>
      </div>
      <div className="counting_box fb_50">
        <p className="tit">
          <i className="order_icon"></i>
          <span>{t('total_order_count')}</span>
        </p>
        <p className="number">{myInfo?.order_count}</p>
      </div>
      <div className="counting_box fb_50">
        <p className="tit">
          <i className="payment_icon"></i>
          <span>{t('total_order_amount')}</span>
        </p>
        <p className="number">{formatLocalString(myInfo?.order_sum || 0)}</p>
      </div>

      {/* 장비사용평점 */}
      <EquipmentRatingPopup isPopup={isEquipmentPopup} setIsPopup={setEquipmentPopup}/>
    </div>
  )
};

export default MyTop;